// extracted by mini-css-extract-plugin
export default {"drawer":"kjt35","drawerContent":"SBb7z","agreement":"oQFYJ","drawerFooter":"ijj7l","drawerClose":"v3jTG"};